import { LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SuppliersContext } from 'Context/SuppliersContext';

export const LinkReturnToLobby = () => {
  const { setStepIndex } = useContext(SuppliersContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <LinkReturnToMain
      label={Dictionary[DICTIONARY.General].back}
      onClick={() => {
        setStepIndex(SUPPLIERS_STEPS.FORM);
        navigate(pathname.replace(/\/results$/, ''));
      }}
    />
  );
};
